import React from 'react';
import { TouchableOpacity } from 'react-native';
import Icon, { ICON_SIZES } from './Icon';
import type { IconName } from './Icon';
import { useTheme } from '../theme/ThemeContext';
import { useThemedStyles } from '../theme/useThemedStyles';
import type { Theme } from '../theme/types';

interface FloatingActionButtonProps {
  onPress: () => void;
  icon?: IconName;
  accessibilityLabel: string;
  testID?: string;
}

export default function FloatingActionButton({
  onPress,
  icon = 'add',
  accessibilityLabel,
  testID = 'fab-button',
}: FloatingActionButtonProps) {
  const styles = useThemedStyles(createStyles);
  const { colors } = useTheme();

  return (
    <TouchableOpacity
      style={styles.fab}
      onPress={onPress}
      activeOpacity={0.8}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      testID={testID}
    >
      <Icon name={icon} size={ICON_SIZES.fab} color={colors.onPrimary} />
    </TouchableOpacity>
  );
}

const createStyles = (theme: Theme) => ({
  fab: {
    position: 'absolute' as const,
    right: 20,
    bottom: 24,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: theme.colors.primary,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    ...theme.shadows.fab,
  },
});
